export class ImportGoogleDocsHelper {
  static recievedPageCount(totalPages: number, importedPageCount: number) {
    return !!totalPages && !importedPageCount;
  }

  static templateUploaded(totalPages: number, importedPageCount: number) {
    return !totalPages && !importedPageCount;
  }

  static completed(totalPages: number, importedPageCount: number) {
    return totalPages === importedPageCount;
  }
}
